import styles from "./style.module.scss";
import { Link } from "react-router-dom";
import Fishing01 from "src/assets/activity/fishing/01.jpg";
import Fishing02 from "src/assets/activity/fishing/02.jpg";
import Fishing03 from "src/assets/activity/fishing/03.jpg";
import Fishing04 from "src/assets/activity/fishing/04.jpg";
import Fishing05 from "src/assets/activity/fishing/05.jpg";
import Fishing06 from "src/assets/activity/fishing/06.jpg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const IMAGES = [
  Fishing01,
  Fishing02,
  Fishing03,
  Fishing04,
  Fishing05,
  Fishing06,
];

export const FishingSection = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <p id="fishing" className={styles.sectionTitle}>
          釣り船に乗って旬の魚をフィッシング
        </p>

        <Slider {...settings}>
          {IMAGES.map((src, i) => (
            <img src={src} alt={`slide-${i}`} key={i} />
          ))}
        </Slider>

        <p className={styles.description}>
          自身が漁に出て、石巻市内中心部の「割烹スタンド
          松ばる」で新鮮な海鮮料理を提供するガイドの木下智也さんが、その経験を生かして魚がよく釣れるポイントへ船でご案内。釣具レンタルも充実しており、手ぶらでも参加可能です。釣った魚はその場で捌き、海の新鮮な味も堪能できます。釣る喜びと食べる楽しさをフルで体感でき、石巻の海がより身近に感じる体験です。
        </p>
        <h3>information -詳細情報-</h3>

        <ul>
          <li>
            <p className={styles.head}>体験場所</p>
            <p className={styles.body}>
              当日の天候や予定などに合わせて決定（石巻市内）
            </p>
          </li>
          <li>
            <p className={styles.head}>体験人数</p>
            <p className={styles.body}>2〜4名</p>
          </li>
          <li>
            <p className={styles.head}>体験可能時間</p>
            <p className={styles.body}>当日の天候や予定などに合わせて決定</p>
          </li>
          <li>
            <p className={styles.head}>所要時間</p>
            <p className={styles.body}>6〜7時間</p>
          </li>
          <li>
            <p className={styles.head}>料金</p>
            <p className={styles.body}>
              1名あたり15,000円（釣具レンタル・ガイド付き）
            </p>
          </li>
          <li>
            <p className={styles.head}>予約方法</p>
            <p className={styles.body}>
              <Link to="/reservation">ご予約ページ</Link>で選択ください
            </p>
          </li>
        </ul>
        <p className={styles.ulInfo}>
          ※料金は時期などによって変動する可能性があるため、詳しくは店舗にご確認ください。
        </p>
      </div>
    </section>
  );
};
